<div class="cpcontent">
    <h2>Sensors</h2>
    <div class="row">
        <div class="col-md-8">
            <button class="btn btn-primary" (click)="addSensor()">Add</button>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name
                            <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(sensors,'name',sortArray)"></i>
                        </th>
                        <th>Sequence Number</th>
                        <th>Units</th>
                        <th>Default Max Reading</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let s of sensors">
                        <td>{{s.id}}</td>
                        <td class="link" (click)="selectSensor(s)">{{s.name}}</td>
                        <td>{{s.seqNo}}</td>
                        <td>{{s.units}}</td>
                        <td>{{s.defaultMaxGPSReading}}</td>
                        <td>{{s.description}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-4">
            <h4 *ngIf="sensor.id > 0">Edit Sensors</h4>
            <h4 *ngIf="sensor.id == 0">Add Sensors</h4>
            Id: {{sensor.id}}<br>
            <sa-input-text class="inlineform" [(text)]="sensor.name" [title]="'Name'" [required]="'none'"></sa-input-text>
            <sa-input-number class="inlineform" [(text)]="sensor.seqNo" [title]="'Sequence Number'" [required]="'none'"></sa-input-number>
            <sa-input-text class="inlineform" [(text)]="sensor.description" [title]="'Description'" [required]="'none'"></sa-input-text>
            <sa-input-text class="inlineform" [(text)]="sensor.units" [title]="'Units'" [required]="'none'"></sa-input-text>
            <sa-input-number class="inlineform" [(text)]="sensor.defaultMaxGPSReading" [title]="'Default Max'" [required]="'none'"></sa-input-number>
            <button class="btn btn-primary" (click)="save()">Save</button>
        </div>
    </div>
</div>